module.exports = __webpack_public_path__ + "media/application/images/svgs/refresh-cw-f70aa21b6548fa3e664c8135f2cf7c2c.svg";